export default __webpack_public_path__ + "static/media/animated-loader.0562574e.gif";